import React, { useState, useEffect } from 'react';
import { WifiOff } from 'lucide-react';

const OfflineBanner = () => {
  const [isOffline, setIsOffline] = useState(!navigator.onLine);

  useEffect(() => {
    const goOffline = () => setIsOffline(true);
    const goOnline = () => setIsOffline(false);
    
    window.addEventListener('offline', goOffline);
    window.addEventListener('online', goOnline);
    
    return () => {
      window.removeEventListener('offline', goOffline);
      window.removeEventListener('online', goOnline);
    };
  }, []);

  if (!isOffline) return null;

  return (
    <div 
      className="fixed top-0 left-0 right-0 z-[9999] bg-orange-600 text-white text-center py-2 text-sm flex items-center justify-center gap-2"
      data-testid="offline-banner"
    >
      <WifiOff className="w-4 h-4" />
      Mode hors-ligne - Les donnees affichees peuvent ne pas etre a jour
    </div>
  );
};

export default OfflineBanner;
